import { Dispatch } from 'redux';

import { RootState } from '../reducers/store';

import { RoleType } from 'src/types';
import { RolesReducerActionType } from 'src/reducers/rolesReducer';

export const LIST_ROLES = 'list_roles';

export const getRoles =
  () =>
  (dispatch: Dispatch<RolesReducerActionType>, getState: () => RootState) => {
    const {
      client: { get },
    } = getState();

    get(`/roles`, (response: { data: Array<RoleType> }): void => {
      response.data &&
        dispatch({
          type: LIST_ROLES,
          payload: response.data,
        });
    });
  };
